<template>
  <div class="webapp-layout-sidebar">
    <div class="Navigation">
      <div class="Navigation-miniSidebar">
        <div class="Navigation-SidebarHeader mb-4 dropleft">
          <!-- <button type="button" class="Navigation-openButton" @click.prevent.stop="toggle3()">
            <i class="pz-icon icon-menu"></i>
          </button> -->

          <a
            class="Navigation-logo d-flex justify-content-center align-items-center"
            :href="dashboardPage"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="40" height="40" rx="20" fill="white" />
              <path
                d="M32.4939 19.7211C32.3462 19.5638 32.0975 19.5542 31.9374 19.6969L20.3798 30.124C20.2001 30.0393 19.9957 29.9934 19.8036 29.9934C19.6139 29.9934 19.4095 30.0418 19.2298 30.124L7.66976 19.6945C7.50968 19.5493 7.26095 19.5614 7.11319 19.7187C6.96542 19.876 6.97774 20.1204 7.13781 20.2656L18.9219 30.896C19.0377 31 19.2027 31.0266 19.3455 30.9637C19.3898 30.9444 19.4292 30.9177 19.4612 30.8863C19.5425 30.8137 19.6829 30.7653 19.8011 30.7653C19.9193 30.7653 20.0572 30.8137 20.1385 30.8839C20.173 30.9177 20.2148 30.9468 20.2592 30.9661C20.3084 30.9879 20.3626 31 20.4168 31C20.5153 31 20.6113 30.9637 20.6828 30.8984L32.4669 20.2704C32.6294 20.1228 32.6417 19.8784 32.4939 19.7211Z"
                fill="#007681"
              />
              <path
                d="M32.3586 16.9722L26.1846 11.4065C25.862 11.1089 25.6551 11 25.2192 11H19.8012H14.3832C13.9473 11 13.7429 11.1089 13.4178 11.4065L7.24381 16.9722C7.08127 17.1222 7 17.3472 7 17.5723C7 17.7973 7.08127 18.0224 7.24135 18.1724L19.1831 28.9577C19.3456 29.1053 19.5869 29.19 19.7987 29.19C20.0105 29.19 20.2543 29.1053 20.4169 28.9577L32.3586 18.1724C32.5211 18.0248 32.5999 17.7973 32.5999 17.5723C32.6024 17.3472 32.5211 17.1222 32.3586 16.9722ZM17.932 18.6903C17.9123 18.6927 14.8314 18.6951 14.8314 18.6951V21.2601H13.605L13.2652 20.9577V14.3829L13.5902 14.0926L14.8339 14.0877V17.1561H17.4518C17.7227 17.1561 17.964 16.9407 17.964 16.6745V15.6292H15.3486V14.0877H19.2052L19.5328 14.3878L19.5352 17.0762C19.5352 17.9546 18.8186 18.6685 17.932 18.6903ZM26.3126 15.6267H26.3102L24.0346 17.6715L23.1874 18.4362V18.4434L22.0817 19.4428C21.9167 19.5929 21.9659 19.7187 22.1925 19.7187H23.1874H24.1824C24.4065 19.7187 24.4582 19.5953 24.2932 19.4428L23.7095 18.9153V18.6999H25.1773L26.3102 19.7163H26.3126V20.9577L25.9851 21.2601H24.4508H23.1874H21.9561H20.3898L20.0623 20.9577V19.7163H20.0647L20.6829 19.1597L23.1874 16.8996V16.8972L24.2932 15.8978C24.4582 15.7477 24.4089 15.6219 24.1824 15.6219H23.1874H22.1925C21.9684 15.6219 21.9167 15.7453 22.0817 15.8978L22.6653 16.4253V16.6407H21.1976L20.0647 15.6243H20.0623V14.3781L20.3898 14.0829H21.9241H23.1874H24.4188H25.9752L26.3126 14.3878V15.6267Z"
                fill="#007681"
              />
            </svg>
          </a>

          <!-- <div class="dropdown-menu">
            <a class="dropdown-item py-2" :href="dashboardPage"
              ><i class="pz-icon icon-study mr-1 text-secondary"></i>课程首页</a
            >
            <a class="dropdown-item py-2" :href="landingPage">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.1835 11.8359L12.5296 2.18907C12.4601 2.11942 12.3776 2.06417 12.2867 2.02647C12.1958 1.98877 12.0984 1.96936 12 1.96936C11.9016 1.96936 11.8041 1.98877 11.7132 2.02647C11.6223 2.06417 11.5398 2.11942 11.4703 2.18907L1.81636 11.8359C1.53511 12.1172 1.37573 12.4992 1.37573 12.8977C1.37573 13.725 2.04839 14.3977 2.87573 14.3977H3.89292V21.2813C3.89292 21.6961 4.22808 22.0313 4.64292 22.0313H10.5V16.7813H13.125V22.0313H19.357C19.7718 22.0313 20.107 21.6961 20.107 21.2813V14.3977H21.1242C21.5226 14.3977 21.9046 14.2406 22.1859 13.957C22.7695 13.3711 22.7695 12.4219 22.1835 11.8359V11.8359Z"
                  fill="#ADB5BD"
                />
              </svg>

              官网首页</a
            >
          </div> -->
        </div>
        <div class="Navigation-linkContainer">
          <router-link
            :to="dashboardPage"
            class="Navigation-link my-2 is-active"
          >
            <i class="pz-icon icon-study mb-1"></i>
            <span>我的课程</span>
          </router-link>
          <router-link :to="bookmarkPage" class="Navigation-link my-2">
            <i class="pz-icon icon-bookmarks mb-1"></i>
            <span>视频收藏</span>
          </router-link>
          <router-link
            :to="notesPage"
            class="Navigation-link my-2"
            href="javascript:undefined"
          >
            <i class="pz-icon icon-note mb-1"></i>
            <span>课程笔记</span>
          </router-link>
          <router-link
            :to="qaPage"
            class="Navigation-link my-2"
            href="javascript:undefined"
          >
            <div>
              <i class="pz-icon icon-question-answer mb-1"></i>
              <span
                class="badge badge-danger _badge-dot ml-n1"
                :class="isShowQAnew ? '' : 'ofHidden'"
              ></span>
            </div>
            <span>有问必答</span>
          </router-link>
          <router-link
            :to="eventsPage"
            class="Navigation-link my-2"
            href="javascript:undefined"
          >
            <i class="pz-icon icon-activity mb-1"></i>
            <span>模拟考试</span>
          </router-link>
          <router-link
            :to="alumniPage"
            class="Navigation-link my-2"
            href="javascript:undefined"
          >
            <i class="pz-icon icon-alumni mb-1"></i>
            <span>校友会</span>
          </router-link>
        </div>

        <div class="Navigation-sidebarFooter">
          <!-- <hr class="Navigation-divider" /> -->
          <router-link :to="allCoursesPage" class="Navigation-link">
            <i class="pz-icon icon-note-list mb-1"></i>
            <span>试听课</span>
          </router-link>

          <a :href="redirectUrl.MALL_PAGE" class="Navigation-link">
            <svg
              class="mb-1"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.7478 5.52619C21.6729 5.46895 21.583 5.43217 21.4877 5.41979C21.3924 5.40741 21.2954 5.41989 21.2071 5.45589L12.6013 8.99876C12.2271 9.15376 11.7585 9.22744 11.2775 9.22744C10.6067 9.22998 9.91267 9.08177 9.42893 8.88019C9.28152 8.82116 9.14115 8.74733 9.01022 8.65998C9.04586 8.64304 9.0904 8.6244 9.1394 8.60577L16.9665 5.3839L18.1336 5.8582V4.47172C18.1353 4.37284 18.1136 4.27487 18.0699 4.18511C18.0263 4.09535 17.9618 4.01614 17.8815 3.95337C17.8068 3.89619 17.7172 3.85944 17.6222 3.84705C17.5273 3.83467 17.4306 3.84712 17.3425 3.88307L8.73673 7.42594C8.47125 7.52758 8.24319 7.65293 8.05076 7.83503C7.82793 8.04403 7.70138 8.32851 7.69887 8.6261C7.69887 8.63457 7.70154 8.64896 7.70154 8.64896V21.1248L7.69976 21.1418C7.69976 21.1451 7.70243 21.1468 7.70243 21.1502V21.1638H7.70421C7.72203 21.6 7.95366 21.8778 8.17459 22.0743C8.86947 22.657 10.0365 22.9831 11.2784 23C11.8663 23 12.4632 22.9153 13.0156 22.69L21.624 19.1463C21.8512 19.0531 21.9999 18.8219 21.9999 18.5602V6.04454C22.0013 5.94572 21.9794 5.84786 21.9358 5.75817C21.8921 5.66847 21.8279 5.5892 21.7478 5.52619V5.52619ZM16.2895 3.15468C16.2743 2.96835 16.1933 2.79048 16.049 2.68377C15.974 2.62653 15.8841 2.58975 15.7888 2.57736C15.6936 2.56498 15.5966 2.57746 15.5082 2.61347L6.90243 6.15464C6.52827 6.30879 6.05878 6.38332 5.57861 6.38332C4.90779 6.38502 4.2138 6.2368 3.73006 6.03437C3.5825 5.97633 3.44209 5.90305 3.31135 5.81585C3.34699 5.79892 3.39153 5.78028 3.44053 5.76165L11.2686 2.53978L12.4356 3.01408V1.62929C12.4372 1.53036 12.4153 1.43236 12.3715 1.34261C12.3276 1.25286 12.2631 1.17367 12.1826 1.11094C12.1078 1.05378 12.018 1.01704 11.9229 1.00465C11.8278 0.99227 11.731 1.00471 11.6427 1.04065L3.03697 4.58436C2.77149 4.686 2.54432 4.8105 2.351 4.99345C2.1285 5.20259 2.00228 5.48706 2 5.78452C2 5.79468 2.00267 5.80823 2.00267 5.80823V18.3239H2.00445C2.02227 18.7601 2.2539 19.0379 2.47483 19.2344C3.16971 19.8171 4.33674 20.1423 5.5795 20.1593C5.91699 20.1574 6.2534 20.1228 6.58351 20.0559V8.64812C6.5746 8.05524 6.82404 7.48608 7.26235 7.07614C7.56601 6.7961 7.9268 6.57818 8.32248 6.43584L16.2895 3.15468V3.15468Z"
                fill="white"
                fill-opacity="0.6"
              />
            </svg>

            <span>品职商城</span>
          </a>
        </div>
      </div>
      <div class="Navigation-overlay"></div>
      <div class="Navigation-sidebar">
        <div class="Navigation-sidebarHeader">
          <a :href="landingPage" class="Navigation-logo">
            <svg
              width="136"
              height="40"
              viewBox="0 0 136 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M49.8412 11.9459L37.7063 0.813542C37.0712 0.220443 36.6671 0 35.8063 0H25.1621H14.5125C13.657 0 13.2529 0.220443 12.6178 0.813542L0.477628 11.9459C0.15746 12.2451 0 12.6965 0 13.1479C0 13.5993 0.15746 14.0506 0.477628 14.3446L23.9496 35.9165C24.2645 36.2105 24.7422 36.3784 25.1621 36.3784C25.5819 36.3784 26.0596 36.2105 26.3745 35.9165L49.8465 14.3446C50.1666 14.0454 50.3241 13.594 50.3241 13.1479C50.3189 12.6965 50.1614 12.2451 49.8412 11.9459Z"
                fill="#007B83"
              />
              <path
                d="M50.1089 17.4465C49.8202 17.1316 49.3321 17.1106 49.0172 17.3993L26.2958 38.2522C25.9389 38.0842 25.54 37.9898 25.1621 37.9898C24.7894 37.9898 24.3853 38.0842 24.0336 38.2522L1.31216 17.394C0.997244 17.1054 0.509119 17.1264 0.220443 17.4413C-0.0682333 17.7562 -0.0472387 18.2443 0.267681 18.533L23.43 39.7953C23.6557 40 23.9811 40.0577 24.2645 39.9318C24.3485 39.895 24.4272 39.8425 24.4955 39.7743C24.6582 39.6326 24.9311 39.5329 25.1673 39.5329C25.4035 39.5329 25.6712 39.6274 25.8339 39.7691C25.9021 39.8373 25.9808 39.895 26.0701 39.9318C26.1698 39.9738 26.2748 39.9948 26.3797 39.9948C26.5739 39.9948 26.7576 39.9213 26.9046 39.7901L50.0617 18.5278C50.3766 18.2496 50.3976 17.7562 50.1089 17.4465Z"
                fill="#49BCBD"
              />
              <path
                d="M24.6319 6.77602L23.9864 6.17242H16.4073V9.25863H21.551V11.3476C21.551 11.8777 21.0734 12.3081 20.5432 12.3081H15.3943V6.17242L12.9484 6.18292L12.3081 6.76552V19.9187L12.9747 20.5222H15.3838V15.3891C15.3838 15.3891 21.4355 15.3838 21.4775 15.3786C23.2253 15.3366 24.6319 13.9089 24.6319 12.1506V6.77602Z"
                fill="white"
              />
              <path
                d="M31.8121 14.8904V14.8747L33.4759 13.3473L37.9478 9.25863H37.953V6.77602L37.2917 6.17242H34.2317H31.8121H29.3295H26.3168L25.6712 6.76552V9.25863H25.6764L27.9019 11.2951H30.7834V10.8647L29.6392 9.80974C29.3137 9.50532 29.4135 9.25863 29.8544 9.25863H31.8121H33.7698C34.2107 9.25863 34.3105 9.50532 33.985 9.80974L31.8121 11.8095L26.8889 16.3286L25.6764 17.4413H25.6712V19.9239L26.3168 20.5275H29.3977H31.8173H34.3H37.3127L37.9583 19.9239V17.4413H37.953L35.7276 15.4048H32.8461V15.8352L33.9903 16.8902C34.3157 17.1946 34.216 17.4413 33.7751 17.4413H31.8173H29.8596C29.4187 17.4413 29.319 17.1946 29.6444 16.8902L31.8121 14.8904Z"
                fill="white"
              />
              <path
                d="M132.293 29.7074H122.2V28.6157H132.293V27.3402H122.2V27.2563V24.5375H120.547V33.4549H122.2V30.9881H132.293V29.7074Z"
                fill="white"
              />
              <path
                d="M135.999 18.7954V17.5148H128.656L128.199 16.2341H126.54L126.997 17.5148H119.339V18.7954H123.633L120.447 21.3305V22.6164C120.447 22.6164 133.978 22.6164 133.994 22.6164C134.576 22.6164 135.043 22.1441 135.043 21.5667C135.043 21.446 135.017 21.3358 134.98 21.2256C134.97 21.1888 134.954 21.1468 134.933 21.1153C134.917 21.0786 134.896 21.0471 134.875 21.0104C134.87 20.9999 134.86 20.9841 134.854 20.9736C134.791 20.8791 134.713 20.7899 134.618 20.7059L133.07 19.357H130.991L132.876 20.8424C132.944 20.8896 132.991 20.9736 132.991 21.0681C132.991 21.2151 132.87 21.3305 132.729 21.3305H122.468L125.617 18.7954H135.999Z"
                fill="white"
              />
              <path
                d="M123.328 25.8234H133.353C133.353 25.8234 133.358 31.1613 133.358 31.1718C133.358 31.6966 132.933 32.1218 132.408 32.1218C132.398 32.1218 128.577 32.1218 127.958 32.1218V33.4602H133.128C134.167 33.4549 135.007 32.6099 135.007 31.5654C135.007 31.5602 135.007 24.5375 135.007 24.5375H123.334V25.8234H123.328Z"
                fill="white"
              />
              <path
                d="M112.044 29.6601C112.353 29.1615 112.621 28.6314 112.852 28.0646C113.555 26.4217 113.923 23.9234 113.949 21.0996C113.949 20.9736 113.949 19.42 113.949 18.8164H114.563V17.478C113.949 17.478 110.123 17.478 110.112 17.478C109.587 17.478 109.167 17.0581 109.162 16.5333C109.162 16.4545 109.162 16.3601 109.162 16.2341H107.514C107.514 16.6015 107.514 16.8062 107.514 16.9217C107.514 17.9609 108.354 18.8059 109.393 18.8164H112.485C112.485 19.42 112.485 20.9789 112.485 21.0996C112.479 23.7764 112.217 25.9913 111.697 27.2143C111.545 27.6394 111.356 28.0488 111.141 28.4425C110.411 27.2353 110.002 25.5085 109.913 23.262C109.855 20.9789 109.907 20.0289 109.907 19.9869H108.464C108.464 20.0236 108.422 21.1468 108.469 23.2463C108.585 25.9493 109.188 28.0855 110.291 29.6496C109.561 30.5104 108.601 31.2242 107.409 31.8121V33.4392C108.999 32.7726 110.259 31.8436 111.193 30.7834C112.128 31.7754 113.288 32.7936 114.663 33.4392V31.8121C113.534 31.2662 112.742 30.4107 112.044 29.6601Z"
                fill="white"
              />
              <path
                d="M106.832 17.1578H105.178C105.147 17.2786 105.11 17.4098 105.068 17.5358H103.331V16.2603H101.683V17.5358H99.0953V18.8112H101.683V21.3253H97.9563V22.6007H102.759C101.651 24.1176 100.114 25.3195 97.9563 25.54V26.8259C99.1845 26.7261 100.26 26.364 101.2 25.8234H103.599L101.688 27.1985V28.3322L97.9616 28.7154V29.8911V29.9961L101.688 29.6392V30.9513C101.688 31.3975 101.615 31.7071 101.468 31.8856C101.294 32.1008 100.974 32.211 100.518 32.211H99.1005V33.4287H101.216C101.972 33.4287 102.528 33.2345 102.88 32.8408C103.205 32.4734 103.347 32.0168 103.347 31.1193V29.4869L107.257 29.109V29.0251V27.8441V27.8336L105.278 28.0226L103.341 28.201V28.0436L106.401 25.8339V24.5585H102.895C103.509 23.9706 104.045 23.3093 104.501 22.6112H107.252V21.3358H105.252C106.039 19.8189 106.538 18.2916 106.832 17.1578ZM103.567 21.3305H103.331V18.8164H104.659C104.375 19.63 104.019 20.496 103.567 21.3305Z"
                fill="white"
              />
              <path
                d="M84.9396 28.39L84.0369 28.5054V17.5358H84.9396V16.2341H77.2556V17.5358H82.3783V21.3463H79.7592V18.8007H78.1164L78.1006 29.277L77.2504 29.3872V30.6679L82.3731 30.0171V33.4182H84.0264V29.8071L84.9291 29.6916V28.39H84.9396ZM82.3835 28.7259L79.7645 29.067V25.8286H82.3835V28.7259ZM82.3835 24.5427H79.7645V22.6217H82.3835V24.5427Z"
                fill="white"
              />
              <path
                d="M91.553 26.9676H89.8996C90.0781 28.4057 90.8234 31.5234 93.9044 33.4497H93.9096L93.9044 31.8226C92.0988 30.2847 91.7262 28.0961 91.553 26.9676Z"
                fill="white"
              />
              <path
                d="M84.9134 31.8226L84.9082 33.4497H84.9134C87.9944 31.5182 88.7397 28.4057 88.9181 26.9676H87.2648C87.0916 28.0961 86.7189 30.2847 84.9134 31.8226Z"
                fill="white"
              />
              <path
                d="M91.4532 25.8444C92.4925 25.8391 93.3322 24.9941 93.3322 23.9496C93.3322 23.9339 93.3322 16.2341 93.3322 16.2341H88.3618V17.5148H91.6789C91.6789 17.5148 91.6842 23.5245 91.6842 23.556C91.6842 24.0808 91.259 24.506 90.7342 24.506C90.7237 24.506 87.2438 24.506 87.2438 24.506V16.2341H85.5905V25.8444H91.4532Z"
                fill="white"
              />
              <path
                d="M68.2122 25.8339H71.2459C71.2459 25.8339 71.2512 31.1455 71.2512 31.1718C71.2512 31.6966 70.826 32.1218 70.3011 32.1218C70.2907 32.1218 67.1152 32.1218 67.1152 32.1218V24.5112H65.4619V33.4602H71.0202C72.0594 33.4549 72.8992 32.6099 72.8992 31.5654C72.8992 31.5497 72.8992 24.548 72.8992 24.548H68.2122V25.8339Z"
                fill="white"
              />
              <path
                d="M58.9903 25.8339H62.024C62.024 25.8339 62.0293 31.1455 62.0293 31.1718C62.0293 31.6966 61.6041 32.1218 61.0793 32.1218C61.0688 32.1218 57.8933 32.1218 57.8933 32.1218V24.5112H56.24V33.4602H61.7983C62.8376 33.4549 63.6773 32.6099 63.6773 31.5654C63.6773 31.5497 63.6773 24.548 63.6773 24.548H58.9903V25.8339V25.8339Z"
                fill="white"
              />
              <path
                d="M57.9773 19.4935V20.0079V22.6217H69.3196C70.3589 22.6164 71.1987 21.7714 71.1987 20.7269C71.1987 20.7112 71.1987 16.2288 71.1987 16.2288H61.2367V17.5095H69.5453C69.5453 17.5095 69.5506 20.3018 69.5506 20.328C69.5506 20.8529 69.1255 21.278 68.6006 21.278C68.5901 21.278 59.6306 21.278 59.6306 21.278V19.4778C60.166 19.1838 60.5386 18.617 60.5386 17.9609C60.5386 17.0004 59.7618 16.2236 58.8013 16.2236C57.8461 16.2236 57.064 17.0004 57.064 17.9609C57.0588 18.6327 57.4314 19.1996 57.9773 19.4935ZM58.7961 17.4675C59.0743 17.4675 59.3 17.6932 59.3 17.9714C59.3 18.2496 59.0743 18.4753 58.7961 18.4753C58.5179 18.4753 58.2922 18.2496 58.2922 17.9714C58.2922 17.6932 58.5179 17.4675 58.7961 17.4675Z"
                fill="white"
              />
              <path
                d="M122.901 6.28264H120.844H120.592H120.067C119.49 6.28264 119.18 6.60281 119.18 7.20115V7.84149V8.07243V10.681C119.18 11.2846 119.485 11.5995 120.067 11.5995H122.901C123.479 11.5995 123.788 11.2794 123.788 10.681V7.1959C123.788 6.60281 123.484 6.28264 122.901 6.28264ZM123.022 10.4448C123.022 10.6548 122.98 10.7492 122.949 10.7912C122.901 10.8542 122.807 10.891 122.66 10.891H120.309C120.167 10.891 120.067 10.8595 120.02 10.7912C119.988 10.7492 119.946 10.6495 119.946 10.4448V7.44259C119.946 7.23265 119.988 7.13817 120.02 7.09618C120.067 7.0332 120.167 6.99646 120.309 6.99646H122.66C122.802 6.99646 122.901 7.02795 122.949 7.09618C122.98 7.13817 123.022 7.23789 123.022 7.44259V10.4448Z"
                fill="white"
              />
              <path
                d="M110.515 10.2926C110.184 10.2926 109.916 10.5603 109.916 10.8909C109.916 11.2216 110.184 11.4893 110.515 11.4893C110.845 11.4893 111.113 11.2216 111.113 10.8909C111.113 10.5603 110.845 10.2926 110.515 10.2926Z"
                fill="white"
              />
              <path
                d="M88.7327 6.28264H87.4992V7.0017H88.7274C89.5619 7.0017 89.9661 7.36911 89.9661 8.12492V9.79399C89.9661 10.5498 89.5619 10.9172 88.7274 10.9172H86.9114V7.52132V7.0017V6.28264H86.2291H86.1346V6.37711V11.547V11.6415H86.2291H88.7327C89.3677 11.6415 89.8664 11.4841 90.2075 11.1744C90.5592 10.8595 90.7376 10.3976 90.7376 9.80973V8.10917C90.7376 7.52657 90.5592 7.06994 90.2075 6.75502C89.8611 6.44535 89.3625 6.28264 88.7327 6.28264Z"
                fill="white"
              />
              <path
                d="M78.7287 6.28264H75.4798V7.00695H78.7287V6.28264Z"
                fill="white"
              />
              <path
                d="M74.9444 10.4553V8.53956V8.42409V7.44784V6.28789H74.7607C74.4091 6.28789 74.1256 6.57131 74.1256 6.92297V8.54481V10.9907C74.1256 11.3423 74.4091 11.6258 74.7607 11.6258H75.0442H78.7287V10.9015H75.3223C75.1124 10.8647 74.9444 10.681 74.9444 10.4553Z"
                fill="white"
              />
              <path
                d="M117.831 6.28264H114.635V7.00695H117.831V6.28264Z"
                fill="white"
              />
              <path
                d="M114.047 10.4553V8.53956V8.42409V7.44784V6.28789H113.863C113.512 6.28789 113.228 6.57131 113.228 6.92297V8.54481V10.9907C113.228 11.3423 113.512 11.6258 113.863 11.6258H114.147H117.831V10.9015H114.425C114.215 10.8647 114.047 10.681 114.047 10.4553Z"
                fill="white"
              />
              <path
                d="M96.3957 9.23764C96.4219 9.23764 96.4429 9.21664 96.4429 9.1904C96.4429 9.16416 96.4429 9.02769 96.4429 8.89123V8.88073C96.4429 8.74426 96.4429 8.6078 96.4429 8.58155C96.4429 8.55531 96.4219 8.53432 96.3957 8.53432C96.3694 8.53432 96.233 8.53432 96.0965 8.53432H93.5929V9.23764H96.0965C96.233 9.23764 96.3694 9.23764 96.3957 9.23764Z"
                fill="white"
              />
              <path
                d="M96.7159 6.28264H93.5929V7.0017H96.7159V6.28264Z"
                fill="white"
              />
              <path
                d="M92.9578 10.4763V6.28264H92.7741C92.4225 6.28264 92.139 6.56607 92.139 6.91773V11.0064C92.139 11.3581 92.4225 11.6415 92.7741 11.6415H93.0576H96.7159V10.9172H93.341C93.131 10.891 92.9578 10.702 92.9578 10.4763Z"
                fill="white"
              />
              <path
                d="M82.8857 6.54507C82.8647 6.49258 82.8384 6.41385 82.8174 6.36662C82.8017 6.31938 82.7387 6.28264 82.6862 6.28264C82.6862 6.28264 82.2033 6.28264 82.1613 6.28264C82.1141 6.28264 82.0616 6.31938 82.0459 6.37187C82.0301 6.4191 81.9986 6.50308 81.9776 6.55032L80.1354 11.6363H80.9279L82.2978 7.87823C82.2978 7.87823 82.4185 7.54756 82.5707 7.87823L83.1586 9.51056C83.1796 9.56305 83.1953 9.61029 83.0746 9.61029H82.2768L82.0196 10.3294H83.3475C83.4 10.3294 83.4578 10.3713 83.4735 10.4238L83.9249 11.6363H84.7384L82.8857 6.54507Z"
                fill="white"
              />
              <path
                d="M70.8715 6.54507C70.8505 6.49258 70.8242 6.41385 70.8033 6.36662C70.7875 6.31938 70.7245 6.28264 70.672 6.28264C70.672 6.28264 70.1892 6.28264 70.1472 6.28264C70.0999 6.28264 70.0474 6.31938 70.0317 6.37187C70.016 6.4191 69.9845 6.50308 69.9635 6.55032L68.1212 11.6363H68.9137L70.2836 7.87823C70.2836 7.87823 70.4044 7.54756 70.5566 7.87823L71.1444 9.51056C71.1654 9.56305 71.1812 9.61029 71.0604 9.61029H70.2626L70.0055 10.3294H71.3334C71.3859 10.3294 71.4436 10.3713 71.4593 10.4238L71.9107 11.6363H72.7243L70.8715 6.54507Z"
                fill="white"
              />
              <path
                d="M102.489 6.28264H102.09C101.865 6.28264 101.849 6.40336 101.802 6.52408L100.631 9.91471L100.08 11.631C100.08 11.631 100.19 11.631 100.248 11.631C100.311 11.631 100.4 11.631 100.469 11.631C100.537 11.631 100.626 11.631 100.689 11.631C100.794 11.631 100.904 11.5943 100.983 11.3791L101.865 8.83348C101.891 8.75475 101.933 8.80724 101.933 8.86498V10.1089V11.6363H102.342H102.752V10.1089V6.53982C102.747 6.42435 102.652 6.28264 102.489 6.28264Z"
                fill="white"
              />
              <path
                d="M100.075 9.41084L99.0778 6.52933C99.0305 6.40861 99.0095 6.28789 98.7891 6.28789H98.4007C98.238 6.28789 98.1435 6.42435 98.1435 6.53982V10.1089V11.6363H98.5529V11.61V11.6363H98.9623V10.1089V8.91222C98.9623 8.85448 98.999 8.80199 99.0305 8.88072L99.6551 10.6548L100.075 9.41084Z"
                fill="white"
              />
              <path
                d="M129.494 6.28264H129.095C128.869 6.28264 128.853 6.40336 128.806 6.52408L127.636 9.91471L127.085 11.631C127.085 11.631 127.195 11.631 127.253 11.631C127.316 11.631 127.405 11.631 127.473 11.631C127.541 11.631 127.63 11.631 127.693 11.631C127.798 11.631 127.909 11.5943 127.987 11.3791L128.869 8.83348C128.895 8.75475 128.932 8.80724 128.932 8.86498V10.1089V11.6363H129.342H129.751V10.1089V6.53982C129.751 6.42435 129.656 6.28264 129.494 6.28264Z"
                fill="white"
              />
              <path
                d="M127.079 9.41084L126.082 6.52933C126.035 6.40861 126.014 6.28789 125.793 6.28789H125.405C125.242 6.28789 125.148 6.42435 125.148 6.53982V10.1089V11.6363H125.557V11.61V11.6363H125.967V10.1089V8.91222C125.967 8.85448 126.003 8.80199 126.035 8.88072L126.659 10.6548L127.079 9.41084Z"
                fill="white"
              />
              <path
                d="M104.961 6.40861C104.93 6.36137 104.904 6.31413 104.893 6.30363C104.888 6.29314 104.867 6.28264 104.851 6.28264C104.836 6.28264 104.783 6.28264 104.725 6.28264H104.263C104.211 6.28264 104.127 6.28264 104.08 6.28264C104.032 6.28264 104.017 6.31413 104.038 6.35612C104.064 6.39811 104.106 6.46634 104.137 6.51358L105.402 8.80724L105.849 8.10392L104.961 6.40861Z"
                fill="white"
              />
              <path
                d="M108.405 6.28264H107.964C107.911 6.28264 107.854 6.28264 107.838 6.28264C107.822 6.28264 107.806 6.29314 107.796 6.30363C107.791 6.31413 107.759 6.36137 107.728 6.40861L105.833 9.43708V11.4421C105.833 11.4946 105.833 11.5628 105.833 11.589V11.6363H105.88C105.906 11.6363 105.969 11.6363 106.027 11.6363H106.452C106.505 11.6363 106.573 11.6363 106.599 11.6363H106.646V11.589C106.646 11.5628 106.646 11.4946 106.646 11.4421V9.57879C106.646 9.52631 106.673 9.44233 106.699 9.39509L108.525 6.50833C108.557 6.46109 108.599 6.39286 108.625 6.35087C108.651 6.30888 108.63 6.27739 108.583 6.27739C108.541 6.28264 108.457 6.28264 108.405 6.28264Z"
                fill="white"
              />
              <path
                d="M60.7731 6.50308L60.5316 6.27739H57.7026V7.42684H59.6236V8.20889C59.6236 8.40834 59.4452 8.5658 59.2457 8.5658H57.3247V6.27214L56.4114 6.27739L56.17 6.49258V11.4053L56.4167 11.631H57.3195V9.71526C57.3195 9.71526 59.5816 9.71526 59.5974 9.71001C60.2482 9.69426 60.7731 9.1589 60.7731 8.50282V6.50308Z"
                fill="white"
              />
              <path
                d="M64.3474 9.5368V9.53155L64.9667 8.95945L66.6358 7.43209V6.50308L66.3891 6.27739H65.2449H64.3422H63.4131H62.2899L62.0485 6.49783V7.42684L62.8778 8.1879H63.9538V8.03044L63.5234 7.63679C63.4026 7.52132 63.4394 7.43209 63.6021 7.43209H64.3317H65.0612C65.2239 7.43209 65.2607 7.52657 65.1399 7.63679L64.3264 8.3821L62.4894 10.0722L62.038 10.4868V11.4158L62.2794 11.6415H63.4289H64.3317H65.2607H66.3839L66.6253 11.4158V10.4868L65.796 9.72576H64.7201V9.88846L65.1504 10.2821C65.2712 10.3976 65.2344 10.4868 65.0717 10.4868H64.3422H63.6126C63.4499 10.4868 63.4131 10.3923 63.5339 10.2821L64.3474 9.5368Z"
                fill="white"
              />
            </svg>

            <!-- <img src="https://resources.pzacademy.com/image/logo/pz-logo-white.svg" height="32px" /> -->
          </a>
          <button
            type="button"
            class="Navigation-closeButton"
            @click.prevent.stop="toggle3()"
          >
            <i class="pz-icon icon-close"></i>
          </button>
          <h6 class="Navigation-welcomeMessage text-white">
            {{ userInfo.nickname }}
          </h6>
        </div>
        <div class="Navigation-linkContainer">
          <router-link :to="dashboardPage" class="Navigation-link">
            <i class="pz-icon icon-study mr-4"></i>
            <span>我的课程</span>
          </router-link>
          <router-link :to="bookmarkPage" class="Navigation-link">
            <i class="pz-icon icon-bookmarks mr-4"></i>
            <span>视频收藏</span>
          </router-link>
          <router-link :to="notesPage" class="Navigation-link">
            <i class="pz-icon icon-note mr-4"></i>
            <span>课程笔记</span>
          </router-link>
          <router-link :to="qaPage" class="Navigation-link is-active">
            <i class="pz-icon icon-question-answer mr-4"></i>
            <span>有问必答</span>
            <span
              class="badge badge-danger _badge-dot ml-1"
              :class="isShowQAnew ? '' : 'ofHidden'"
            ></span>
          </router-link>
          <router-link :to="eventsPage" class="Navigation-link">
            <i class="pz-icon icon-activity mr-4"></i>
            <span>模拟考试</span>
          </router-link>
          <router-link :to="alumniPage" class="Navigation-link">
            <i class="pz-icon icon-alumni mr-4"></i>
            <span>校友会</span>
          </router-link>
          <hr class="Navigation-divider" />
          <h6
            class="text-secondary small pl-3 myCourses-link"
            v-if="userInfo.myCourses && userInfo.myCourses.length"
          >
            我的证书课程
          </h6>

          <router-link
            :to="
              (course.groupType == 1 ? CoursePage : MiniCoursePage) +
              '/' +
              course.courseId
            "
            v-for="(course, idx) of userInfo.myCourses"
            :key="`router-link-${idx}`"
            class="Navigation-link myCourses-link"
          >
            <i
              class="pz-icon icon-dot _xs course-color mr-3 flex-shrink-0"
              :class="'_' + course.cssClassName"
            ></i>
            {{ course.courseName }}
          </router-link>
          <router-link :to="allCoursesPage" class="Navigation-link">
            <i class="pz-icon icon-add mr-4"></i>
            <span>全部试听课程</span>
          </router-link>

          <!-- <a href="/all-courses" class="Navigation-link">
            <i class="pz-icon icon-add mr-4"></i>
            浏览全部课程
          </a>-->

          <!-- <div class="Navigation-sidebarFooter">
            <a class="Navigation-link" target="_blank" href="/referral"
               >我的邀请码 <span class="text-white ml-1">🧧</span></a>
            <a class="Navigation-link" href="/setting"
              >设置</a>
          </div>-->
        </div>

        <!--  -->
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import * as routes from '../constants/routes';
import { REDIRECT_URLS } from '../constants';
import { mapGetters } from 'vuex';

export default {
  name: 'Aside',
  data: () => {
    return {
      // portalURL: PORTAL_URLS,
      landingPage: REDIRECT_URLS.LANDING_PAGE,
      dashboardPage: routes.DASHBOARD_PAGE,
      bookmarkPage: routes.BOOKMARK_PAGE,
      notesPage: routes.NOTES_PAGE,
      eventsPage: routes.EVENTS_PAGE,
      alumniPage: routes.ALUMNI_PAGE,
      qaPage: routes.QA_QUESTION_LIST_PAGE,
      CoursePage: routes.MAIN_MODE_COURSE_PAGE,
      MiniCoursePage: routes.MINI_MODE_COURSE_PAGE,
      FreeCoursePage: routes.FREE_MODE_COURSE_PAGE,
      allCoursesPage: routes.ALL_COURSES_PAGE,
      isOpen: false,
      redirectUrl: {
        ...REDIRECT_URLS,
      },
    };
  },
  // props:{
  //   p_isInCnIframe: {
  //     type: Boolean,
  //     default: () => false,
  //   },
  // },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),

    isShowQAnew() {
      return this.userInfo.totalAandC > 0;
    },
  },

  methods: {
    // toggle2(e) {
    //   console.log(1);
    //   if ($(`body`).hasClass('is-open')) {
    //     $(`body`).removeClass('is-open');
    //   } else {
    //     $(`body`).addClass('is-open');
    //   }
    // },

    toggle3(e) {
      if ($(`body`).hasClass('is-open')) {
        $(`body`).removeClass('is-open');
      } else {
        $(`body`).addClass('is-open');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.ofHidden.ofHidden.ofHidden {
  display: none !important;
}
</style>
